module.exports = __webpack_public_path__ + "static/media/dr-tharuka-old.d463ec2a.jpg";